import type { PublicServiceStatus } from "@/v2-status-client/status/status.types"

// Tailwind class fragments per service status. Stored at module
// scope so every section that wants a coloured dot, halo, or row
// accent can hand us a status enum and read out the look without
// reinventing the colour map. Halo is an arbitrary-property
// utility so the `.status-dot` rule (in `status.css`) can read it
// off a CSS custom property.
export const STATUS_TONE: Record<
  PublicServiceStatus,
  { dot: string; halo: string; text: string }
> = {
  operational: {
    dot: "bg-emerald-400",
    halo: "[--status-dot-halo:rgb(16_185_129_/_0.18)]",
    text: "text-emerald-300",
  },
  degraded: {
    dot: "bg-amber-400",
    halo: "[--status-dot-halo:rgb(245_158_11_/_0.16)]",
    text: "text-amber-300",
  },
  down: {
    dot: "bg-red-400",
    halo: "[--status-dot-halo:rgb(248_113_113_/_0.20)]",
    text: "text-red-300",
  },
}

// Past this many providers we collapse the section to "worst N
// rows + show all" so the page above-the-fold isn't dominated by
// a long alphabetical roll of healthy upstreams. The list is
// already sorted worst-first by the backend, so the first N rows
// are exactly the ones a customer hitting the page during an
// outage actually wants to see.
export const PROVIDERS_COLLAPSED_LIMIT = 6
